async function getJson(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`API request failed (${response.status})`);
  }

  return response.json();
}

export async function fetchCaseStudyBySlug(slug) {
  return getJson(`/api/case-studies/${slug}`);
}

export async function fetchCaseStudyPreviews() {
  const payload = await getJson('/api/case-studies');
  return Array.isArray(payload?.items) ? payload.items : [];
}
